import { defineStorefront } from "@kss/storefront-config"

export function installationStorefront() {
  const origin = process.env.NEXT_PUBLIC_STOREFRONT_ORIGIN
  if (!origin)
    throw new Error(
      "NEXT_PUBLIC_STOREFRONT_ORIGIN is required for installations"
    )
  return defineStorefront({
    id: "instalaciones",
    // Keep existing preview runners compatible during the domain migration.
    origin: origin === "https://habita.kss.cl" ? "https://facilisimo.cl" : origin,
    locale: "es-CL",
    currencyCode: "clp",
    brand: {
      name: "Facilisimo",
      shortName: "Facilisimo",
      logoPath: "/images/facilisimo-logo.png",
      logoWidth: 2160,
      logoHeight: 728,
      iconPath: "/images/facilisimo-icon.png",
    },
    // Legal identity read from IA ERP (DFR); brand assets and email from its
    // existing Facilisimo identity. Verified 2026-10-26.
    business: {
      legalName: "DISTRIBUIDORA DFR SpA",
      taxId: "78.535.769-8",
      address: "Diagonal Paraguay 406, departamento 1112, Santiago, Chile",
      email: "contacto@facilisimo.cl",
      website: "https://facilisimo.cl",
    },
    header: {
      logoDisplay: "image",
      showAccount: true,
      showSearch: true,
      sticky: true,
      desktopCategoryLimit: 4,
    },
    commerce: {
      defaultCountryCode: "cl",
      backendUrlEnv: "NEXT_PUBLIC_MEDUSA_BACKEND_URL",
      publishableKeyEnv: "NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY",
      salesChannelIdEnv: "NEXT_PUBLIC_MEDUSA_SALES_CHANNEL_ID",
      taxPresentation: "gross",
    },
    search: {
      tenant: "instalaciones",
      gatewayUrlEnv: "NEXT_PUBLIC_SEARCH_GATEWAY_URL",
    },
    cache: { namespace: "instalaciones" },
    content: {
      eyebrow: "EQUIPA TU HOGAR. DISFRUTA TU ESPACIO.",
      title: "Equipa tu hogar.\nNosotros también\nlo instalamos.",
      introduction:
        "Elige tu equipo y cómo recibirlo. Con instalación, llevamos tu pedido y lo dejamos listo en una sola visita.",
      heroImage: "/images/equipment-home.png",
      featuredCategory: "facilisimo-calefonts",
      categories: [
        {
          title: "Calefonts",
          handle: "facilisimo-calefonts",
          description: "Agua caliente para tu hogar",
          productHandle: "facilisimo-anwo-37962",
          imageUrl: "https://7376dd722d2c44923eb2.ucr.io/-/preview/800x600/-/quality/smart/-/format/auto/https:/media.anwo2.storefront.cl/prd_productos/37959/18%20con%20logo.jpg",
        },
        {
          title: "Termos de agua caliente",
          handle: "facilisimo-termos",
          description: "Agua caliente acumulada, de 50 a 200 litros",
          productHandle: "facilisimo-anwo-37999",
          imageUrl: "https://7376dd722d2c44923eb2.ucr.io/-/resize/x400/-/quality/smart/-/format/auto/https:/media.anwo2.storefront.cl/prd_productos/37999/PDP-80L_size_555x432.png",
        },
        {
          title: "Termostatos",
          handle: "facilisimo-termostatos",
          description: "Controla la temperatura de tu calefacción",
          productHandle: "facilisimo-anwo-26620",
          imageUrl: "https://7376dd722d2c44923eb2.ucr.io/-/resize/x400/-/quality/smart/-/format/auto/https:/media.anwo2.storefront.cl/prd_productos/26620/00_085_40_ok_size_555x432.jpg",
        },
        {
          title: "Presurizadores domiciliarios",
          handle: "facilisimo-presurizadores",
          description: "Mejora la presión del agua en tu hogar",
          productHandle: "facilisimo-anwo-51361",
          imageUrl: "https://7376dd722d2c44923eb2.ucr.io/-/resize/x400/-/quality/smart/-/format/auto/https:/media.anwo2.storefront.cl/prd_productos/51361/_M.png",
        },
        {
          title: "Aires acondicionados",
          handle: "facilisimo-aires-acondicionados",
          description: "Split muro, portátiles y de ventana para tu hogar",
          productHandle: "facilisimo-anwo-53051",
          imageUrl: "https://7376dd722d2c44923eb2.ucr.io/-/preview/800x600/-/quality/smart/-/format/auto/https:/media.anwo2.storefront.cl/prd_productos/53051/PDP_12000-ECOFLOW-1.jpg",
        },
        {
          title: "Estufas de terraza",
          handle: "facilisimo-estufas-terraza",
          description: "Calefacción exterior de pie o de muro con WiFi",
          productHandle: "facilisimo-anwo-53672",
          imageUrl: "https://7376dd722d2c44923eb2.ucr.io/-/preview/800x600/-/quality/smart/-/format/auto/https:/media.anwo2.storefront.cl/prd_productos/53672/01.jpg",
        },
        {
          title: "Cocina",
          handle: "cocina",
          description: "Hornos, encimeras y extracción",
          productHandle: "horno-electrico-empotrable",
        },
        {
          title: "Agua caliente",
          handle: "agua-caliente",
          description: "Confort en cada rutina",
          productHandle: "termo-electrico-80",
        },
        {
          title: "Climatización",
          handle: "climatizacion",
          description: "Ambientes más agradables",
          productHandle: "purificador-aire",
        },
      ],
      steps: [
        {
          title: "Elige lo que necesitas",
          description:
            "Compara productos, medidas y prestaciones para encontrar el equipo para tu hogar.",
        },
        {
          title: "Decide cómo recibirlo",
          description:
            "Compra solo el producto o agrega instalación en una comuna con cobertura.",
        },
        {
          title: "Nos ocupamos de la puesta en marcha",
          description:
            "Si eliges instalación, el técnico lleva tu pedido y comprueba el funcionamiento.",
        },
      ],
      faqs: [
        {
          question: "¿Puedo comprar sin instalación?",
          answer:
            "Sí. Todos los equipos físicos se pueden comprar con despacho a domicilio. La instalación es opcional para los productos que la ofrecen.",
        },
        {
          question: "¿Qué incluye la instalación?",
          answer:
            "La entrega del pedido, montaje en una conexión existente compatible, prueba de funcionamiento y explicación de uso. Revisa el alcance específico en la ficha; no incluye obras ni cambios de redes.",
        },
        {
          question: "¿Cómo elijo mi horario?",
          answer:
            "En la ficha, elige Con instalación, tu comuna y un día en el calendario. Selecciona la franja y la dirección de la visita. Al reservar y agregar al carrito, guardamos el horario por 15 minutos. Luego completas tus datos y el pago.",
        },
        {
          question: "¿Qué ocurre con los demás productos de mi pedido?",
          answer:
            "Si agregas instalación, todos los artículos físicos del pedido se entregan en esa misma visita. Por ahora se puede instalar una unidad de un producto por pedido.",
        },
        {
          question: "¿Puedo reprogramar la visita?",
          answer:
            "Solicita ayuda indicando tu pedido. El equipo de atención revisará la disponibilidad y gestionará el cambio. Reprogramar o cancelar una cita no cancela automáticamente el pedido ni genera un reembolso.",
        },
      ],
    },
    theme: {
      colorBrand: "#102e68",
      colorBrandHover: "#0b214b",
      colorOnBrand: "#ffffff",
      colorAccent: "#e31b2e",
      colorBackground: "#ffffff",
      colorSurface: "#ffffff",
      colorForeground: "#17324b",
      colorMuted: "#607084",
      colorBorder: "#dce2e8",
      colorFocus: "#102e68",
      colorHeaderBackground: "#ffffff",
      colorHeaderForeground: "#17324b",
      colorHeaderBorder: "#dce2e8",
      colorHeaderInteractive: "#102e68",
      colorHeaderBadgeBackground: "#102e68",
      colorHeaderBadgeForeground: "#ffffff",
      fontSans: "Inter, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
      fontHeading: "Inter, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
      headerHeight: "3.75rem",
      headerLogoMaxWidth: "12rem",
      radiusControl: "0.5rem",
      radiusCard: "1rem",
      shadowCard: "0 12px 32px rgb(15 27 24 / 0.08)",
    },
    features: {
      installationBooking: true,
      creditLine: true,
      blog: false,
      renting: false,
      quotes: false,
      reviews: false,
      wishlist: false,
      receptionist: false,
    },
  })
}
